'use strict';

import * as html2canvas from 'html2canvas';

export function exportImage (
  element = { $styles: [], $title: null, $chart: null, $legend: null },
  options
) {
  return new Promise(async (resolve) => {
    function getClonedNode ($el) {
      const $clonedEl = $el.cloneNode(true);
      return $clonedEl;
    }

    const _options = {
      width: 1168,
      padding: { top: 10, left: 10, bottom: 10, right: 10 },
      fileName: (new Date()).getTime().toString(),
      componentRenderingDelay: 1500,
      exportDelay: 0
    };
    Object.assign(_options, options);

    const oldStyles = {};
    const className = 'exportContainer';
    const width = _options.width - _options.padding.left - _options.padding.right;
    const $exportContainer = document.createElement('div');
    $exportContainer.id = className;
    $exportContainer.style.width = `${width}px`;
    for (const [key, value] of Object.entries(_options.padding)) {
      const paddingName = `padding${key.charAt(0).toUpperCase() + key.slice(1)}`;
      $exportContainer.style[paddingName] = `${value}px`;
    }
    $exportContainer.style.fontFamily = '"Roboto",sans-serif';
    for (const $style of element.$styles) {
      $exportContainer.appendChild($style.cloneNode(true));
    }
    const $container = document.createElement('div');
    $container.style.width = `${width}px`;
    $container.style.display = 'flex';
    const contentContainerWidth = element.$legend ? width * 0.75 : width;
    const $contentContainer = document.createElement('div');
    $contentContainer.style.width = `${contentContainerWidth}px`;
    $contentContainer.style.display = 'flex';
    $contentContainer.style.flexDirection = 'column';
    if (element.$title) {
      $contentContainer.appendChild(getClonedNode(element.$title));
    }
    if (element.$chart) {
      oldStyles.parentChart = {
        element: element.$chart.parentElement,
        styles: { width: element.$chart.parentElement.style.width }
      };
      element.$chart.parentElement.style.width = `${contentContainerWidth}px`;
      window.dispatchEvent(new Event('resize'));
      const waiting$ = new Promise(resolve => setTimeout(() => resolve(), _options.componentRenderingDelay)); // Waiting for component rendering
      await waiting$;
      const $chartContainer = document.createElement('div');
      // $chartContainer.style.width = `${contentContainerWidth}px`;
      $chartContainer.innerHTML = element.$chart.shadowRoot ? element.$chart.shadowRoot.innerHTML : element.$chart.innerHTML;
      const $containerChart = $chartContainer.querySelector('.container-chart');
      if ($containerChart !== null) {
        $containerChart.style.height = 'auto';
      }
      $contentContainer.appendChild($chartContainer);
    }
    if (element.$bottomText) {
      $contentContainer.appendChild(getClonedNode(element.$bottomText));
    }
    $container.appendChild($contentContainer);
    if (element.$legend) {
      const $legendContainer = document.createElement('div');
      $legendContainer.style.width = `${(width * 0.25)}px`;
      const $legendTitle = document.createElement('h5');
      $legendTitle.textContent = 'Data legend';
      $legendContainer.appendChild($legendTitle);
      const $legendWrapper = document.createElement('div');
      $legendWrapper.style.width = '100%';
      $legendWrapper.innerHTML = element.$legend.shadowRoot ? element.$legend.shadowRoot.innerHTML : element.$legend.innerHTML;
      $legendContainer.appendChild($legendWrapper);
      $container.appendChild($legendContainer);
    }
    $exportContainer.appendChild($container);

    const $escapLogoContainer = document.createElement('div');
    $escapLogoContainer.style.paddingRight = '10px';
    $escapLogoContainer.style.cssFloat = 'right';

    const $escapLogo = document.createElement('img');
    $escapLogo.src = '/themes/custom/tbdtheme/assets/src/img/vector_logo.svg';
    $escapLogo.style.height = '49px';
    $escapLogo.style.width = '154px';

    $escapLogoContainer.appendChild($escapLogo);
    $exportContainer.appendChild($escapLogoContainer);

    if (element.$chart.tagName === 'MAP-CHART') {
      const sourceCanvas = document.querySelector('map-chart').shadowRoot.querySelector('.leaflet-pane.leaflet-marker-pane canvas');
      const destCanvas = $exportContainer.querySelector('.leaflet-pane.leaflet-marker-pane canvas');
      const destCtx = destCanvas.getContext('2d');
      destCtx.drawImage(sourceCanvas, 0, 0);
    }

    document.querySelector('body').appendChild($exportContainer);
    setTimeout(() => {
      html2canvas($exportContainer, { useCORS: true, allowTaint: true, scale: 4 }).then(canvas => {
        const $downloadLink = document.createElement('a');
        $downloadLink.download = `${_options.fileName}.png`;
        $downloadLink.href = canvas.toDataURL();
        $downloadLink.click();

        // Clear adjust styles
        const elements = Object.keys(oldStyles);
        for (const elementName of elements) {
          const styles = Object.keys(oldStyles[elementName].styles);
          for (const style of styles) {
            oldStyles[elementName].element.style[style] = oldStyles[elementName].styles[style];
          }
        }
        // Clear temp elements
        $exportContainer.remove();
        $downloadLink.remove();

        resolve(true);
      });
    }, _options.exportDelay); // Wating for rendering
  });
}

const ExportChart = {
  exportImage: exportImage
};

export default ExportChart;
